<div class="container-fluid">
  <div class="d-flex justify-content-between align-items-center">
    <h2>Counselling Induction</h2>

    <button mat-mini-fab
            color="primary"
            permission="Counselling Induction"
            [permissionTypes]="[PermissionType.ADD, PermissionType.ALL]"
            matTooltip="Add New Row"
            (click)="openAddRowDialog()">
      <mat-icon class="col-white">add</mat-icon>
    </button>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="loading" class="text-center p-4">
    <mat-spinner></mat-spinner>
    <p>Loading data...</p>
  </div>

  <!-- No Data Message -->
  <div *ngIf="!loading && rows.length === 0" class="alert alert-warning text-center">
    <mat-icon>info</mat-icon>
    <p class="mb-0 mt-2">No data available</p>
  </div>

  <!-- Table -->
  <form [formGroup]="tableForm" *ngIf="!loading && rows.length > 0">
    <table mat-table [dataSource]="rows.controls" class="mat-elevation-z2 full-table">

      <!-- SR NO -->
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef class="col-srno"> SR.NO </th>
        <td mat-cell *matCellDef="let row; let i = index" class="col-srno"> {{ i + 1 }} </td>
      </ng-container>

      <!-- TOPIC -->
      <ng-container matColumnDef="topic">
        <th mat-header-cell *matHeaderCellDef> TOPIC </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.value.topic }}
        </td>
      </ng-container>

      <!-- INDUCTOR -->
      <ng-container matColumnDef="inductor">
        <th mat-header-cell *matHeaderCellDef> INDUCTOR FOR</th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.value.inductor }}
        </td>
      </ng-container>

      <!-- DATE -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="col-date"> DATE </th>
        <td mat-cell *matCellDef="let row; let i = index" class="col-date">
          {{ row.value.date | date:'dd/MM/yyyy' }}
        </td>
      </ng-container>

      <!-- SUB-TOPIC -->
      <ng-container matColumnDef="subTopic">
        <th mat-header-cell *matHeaderCellDef> SUB-TOPIC </th>
        <td mat-cell *matCellDef="let row; let i = index">
          <div [innerHTML]="row.value.subTopic"></div>
        </td>
      </ng-container>

      <!-- DESCRIPTION -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> DESCRIPTION </th>
        <td mat-cell *matCellDef="let row; let i = index">
          <div [innerHTML]="row.value.description"></div>
        </td>
      </ng-container>

      <!-- FEEDBACK -->
      <ng-container matColumnDef="feedback">
        <th mat-header-cell *matHeaderCellDef> FEEDBACK </th>
        <td mat-cell *matCellDef="let row; let i = index" class="clickable">
          <div [innerHTML]="row.value.feedback || '<i style=\'color:#999\'></i>'"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="conductedBy">
        <th mat-header-cell *matHeaderCellDef> INDUCTOR BY </th>
        <td mat-cell *matCellDef="let row; let i = index" class="clickable">
          <div [innerHTML]="row.value.conductedBy || '<i style=\'color:#999\'></i>'"></div>
        </td>
      </ng-container>


      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="col-action"> ACTIONS </th>

        <td mat-cell *matCellDef="let row; let i = index" class="col-action">

          <button mat-icon-button color="primary"
                  (click)="openEditRowDialog(i)"
                  permission="Counselling Induction"
                  [permissionTypes]="[PermissionType.EDIT]">
            <mat-icon>edit</mat-icon>
          </button>

          <button mat-icon-button color="warn"
                  (click)="deleteRow(i)"
                  permission="Counselling Induction"
                  [permissionTypes]="[PermissionType.ARCHIVE]">
            <mat-icon>delete</mat-icon>
          </button>

        </td>
      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </form>
</div>
<ng-template #addRowDialog>
  <h2 mat-dialog-title class="dialog-title">{{ dialogTitle }}</h2>
  <form [formGroup]="addRowForm" class="p-3">
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Topic</mat-label>
      <input matInput formControlName="topic">
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Inductor By</mat-label>
      <mat-select formControlName="inductorBy">
        <mat-option *ngFor="let e of counsellors$ | async" [value]="e.userName">
          {{ e.userName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

      <mat-form-field appearance="outline" class="col-4">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" placeholder="Select date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Sub Topic</mat-label>
      <textarea matInput formControlName="subTopic"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Feedback</mat-label>
      <textarea matInput formControlName="feedback"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Inductor For</mat-label>
      <mat-select formControlName="inductorFor">
        <mat-option *ngFor="let e of counsellors$|async" [value]="e.userName">
          {{ e.userName }}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <div class="col-12 justify-content-center d-flex gap-2">
      <button mat-button mat-dialog-close color="warn">Cancel</button>
      <button mat-flat-button color="primary" (click)="submitRow()" [disabled]="actionLoading || addRowForm.invalid">
        <mat-spinner *ngIf="actionLoading" diameter="20"></mat-spinner>
        <span *ngIf="!actionLoading">Save</span>
      </button>
    </div>
  </form>
</ng-template>
